import { useState, useEffect } from "react";
import { Frame, Loading, Header, Input, ValidaUid } from "../components";
import { useNavigate } from "react-router-dom";
import { ValidaForm2 } from "../components/Validacao";
import { db, auth, storage } from "../config/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

const Form2 = () => {
  const [erro, setErro] = useState({});
  const [dados, setDados] = useState({});
  const [loading, setLoading] = useState(true);

  let uid = auth.currentUser?.uid;

  const navigate = useNavigate();

  const uploadFile = async (file, docPath, docUrl) => {
    if (!file) return;

    setLoading(true);

    const path = ref(storage, `desconto2026/${uid}/${docPath}`);

    const upload = uploadBytesResumable(path, file, file.type);

    upload.on(
      "state_changed",
      () => {},
      () => {},
      () => {
        getDownloadURL(upload.snapshot.ref).then((url) => {
          setDados({ ...dados, [docUrl]: url });
          setLoading(false);
        });
      },
    );
  };

  const setData = async () => {
    await setDoc(doc(db, "desconto2026", uid), dados, { merge: true });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    const err = ValidaForm2(dados);

    if (err) {
      setErro(err);
      setLoading(false);
    } else {
      setData().then(() => navigate("../form3"));
    }
  };

  const buscaDados = async () => {
    const uid = await ValidaUid();

    if (uid) {
      const qry = await getDoc(doc(db, "desconto2026", uid));

      const data = qry.data();

      if (!data?.status) {
        setLoading(false);
      } else if (data?.status === "e") {
        setLoading(false);
        setDados(data);
      } else {
        navigate("../home");
      }
    }
  };

  useEffect(() => {
    buscaDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={dados?.nome} foto={dados?.urlFoto} />
      <Frame
        body={
          <form
            autoComplete="off"
            onSubmit={handleSubmit}
            className="text-start"
            noValidate
          >
            <div className="row mt-3">
              <div className="col-sm-12">
                <Input
                  id="imgRg"
                  label="RG"
                  type="file"
                  accept=".jpg, .jpeg, .png, .pdf"
                  className={erro.rg && "is-invalid"}
                  onChange={(e) => uploadFile(e.target.files[0], "rg", "urlRg")}
                  erro={erro.rg}
                  url={dados?.urlRg}
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-sm-12">
                <Input
                  id="imgVinculo"
                  label="Comprovante de Vínculo"
                  type="file"
                  accept=".jpg, .jpeg, .png, .pdf"
                  className={erro.vinculo && "is-invalid"}
                  onChange={(e) =>
                    uploadFile(e.target.files[0], "vinculo", "urlVinculo")
                  }
                  erro={erro.vinculo}
                  url={dados?.urlVinculo}
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-sm-12">
                <Input
                  id="imgResidencia"
                  label="Comprovante de Residência"
                  type="file"
                  accept=".jpg, .jpeg, .png, .pdf"
                  className={erro.residencia && "is-invalid"}
                  onChange={(e) =>
                    uploadFile(e.target.files[0], "residencia", "urlResidencia")
                  }
                  erro={erro.residencia}
                  url={dados?.urlResidencia}
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-sm-12 d-grid">
                <button type="submit" className="btn btn-primary">
                  ENVIAR
                </button>
              </div>
            </div>
          </form>
        }
        title="Documentos"
      />
    </>
  );
};

export default Form2;
